<template>
  <v-btn
    v-bind="{
      ...$attrs,
      ...commonAttrs
    }"
    v-on="$listeners"
    ref="btn"
  >
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="data">
      <slot :name="scopedSlotName" v-bind="data"/>
    </template>

    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName"/>
    </template>
  </v-btn>
</template>

<script>
export default {
  name: 'x-btn',
  computed: {
    commonAttrs() {
      return {
        ripple: this.$attrs.ripple ?? false,
        depressed: this.$attrs.depressed ?? true,
        color: this.$attrs.color ?? '#EB6E44',
        height: this.$attrs.height ?? 44,
        width: this.$attrs.width ?? 165
      }
    }
  }
}
</script>

<style scoped>

</style>